import { FunctionComponent } from 'react';
import { StyledCell } from '../styles';
import { CellProps } from '../types';
import StyledLink from 'components/common/Link';

export interface LinkCellProps extends CellProps {
	text: string;
	url: string;
}

const LinkCell: FunctionComponent<LinkCellProps> = ({
	text = '',
	align = 'flex-start',
	justify = 'center',
	url = '',
	offsetLeft,
}) => (
	<StyledCell align={align} justify={justify} $offsetLeft={offsetLeft}>
		<div onClick={(event) => event.stopPropagation()}>
			<StyledLink to={url}>{text}</StyledLink>
		</div>
	</StyledCell>
);

export default LinkCell;
